import * as React from 'react';
export const renderSvg = React.forwardRef(function renderSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#4351E8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.251 6h-.234v2.632h2.644V6h-2.41Zm-6.994 0a6.226 6.226 0 0 0-4.421 1.836A6.226 6.226 0 0 0 6 12.257v9.404h2.643v-9.439a3.748 3.748 0 0 1 1.111-2.491 3.774 3.774 0 0 1 2.515-1.088h5.053V6h-5.064Zm11.333 8.678h-.233v2.644H26v-2.644h-2.409Zm0-4.338h-.233v2.641H26V10.34h-2.409ZM25.766 6h-2.409v2.632H26V6h-.234ZM23.59 19.017h-.233v2.644H26v-2.644h-2.409Zm0 4.34h-.233V26H26v-2.643h-2.409Zm-4.339 0h-.234V26h2.644v-2.643h-2.41Zm-4.339 0h-.234V26h2.644v-2.643h-2.41Zm-4.339 0h-.234V26h2.643v-2.643h-2.409Zm-4.339 0H6V26h2.632v-2.643H6.234Z',
      fill: '#46E3B7',
    }),
  );
});
renderSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var render = {
  category: 'brand',
  colorable: false,
  name: 'render',
  svg: renderSvg,
};
